import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "hop-dong-hdvt-step" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-end gap-2 mb-3 flex-wrap"
}

import { computed, ref } from "vue";
import AddVatTuItems from "@/components/add-vat-tu-items/AddVatTuItems.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import { AddVatTuItemsFor } from "@/core/enums/addVatTuItemsFor.enum";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import type { IVatTuResponseBase } from "@/core/interfaces/ApiResponses";
import type { HopDongHdvtLineDraft } from "@/types/hop-dong";
import HopDongHdvtTable from "./HopDongHdvtTable.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HopDongHdvtStep',
  props: {
    lines: {},
    readonly: { type: Boolean, default: false }
  },
  emits: ["remove-line", "patch-line", "add-existing"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { ButtonTypeColors, ButtonsType } = useButtonCustom();
const isAddExistingOpen = ref(false);

const selectedExistingForModal = computed(() =>
  props.lines
    .filter((line) => line.kind === "existing" && line.id_vat_tu)
    .map((line) => ({
      id: line.id_vat_tu as number,
      id_vat_tu: line.id_vat_tu as number,
      ma_vat_tu: line.ma_vat_tu ?? "",
      ten_vat_tu: line.ten_vat_tu ?? "",
      don_vi_tinh: line.don_vi_tinh ?? "",
      so_luong: line.so_luong,
      so_luong_trong_hop_dong: line.so_luong,
      so_luong_hop_dong: line.so_luong,
      so_luong_nhap: 0,
      so_luong_thieu: line.so_luong,
      don_gia: line.so_tien,
    }))
);

const onExistingAdded = (payload?: {
  vatTuDangChon?: Array<
    IVatTuResponseBase & { so_luong?: number; don_gia?: number }
  >;
}) => {
  isAddExistingOpen.value = false;

  if (payload?.vatTuDangChon?.length) {
    emit("add-existing", payload.vatTuDangChon);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AddVatTuItems, {
      "is-modal-open": isAddExistingOpen.value,
      "use-for": _unref(AddVatTuItemsFor).PHIEU_NHAP_LE,
      "vat-tu-da-chon-items": selectedExistingForModal.value,
      onAdded: onExistingAdded,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddExistingOpen.value = false))
    }, null, 8, ["is-modal-open", "use-for", "vat-tu-da-chon-items"]),
    (!_ctx.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ButtonCustom, {
            "button-type": _unref(ButtonsType).ADD,
            "color-type": _unref(ButtonTypeColors).PRIMARY,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (isAddExistingOpen.value = true))
          }, {
            "button-label": _withCtx(() => [
              _createTextVNode("Thêm vật tư có sẵn")
            ]),
            _: 1
          }, 8, ["button-type", "color-type"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(HopDongHdvtTable, {
      lines: _ctx.lines,
      readonly: _ctx.readonly,
      onRemoveLine: _cache[2] || (_cache[2] = (key) => _ctx.$emit('remove-line', key)),
      onPatchLine: _cache[3] || (_cache[3] = (key, patch) => _ctx.$emit('patch-line', key, patch))
    }, null, 8, ["lines", "readonly"])
  ]))
}
}

})